<script setup>
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

  const { $BRAND } = useConfigurationGlobals();

  const brandClass = `home-brand-${($BRAND || '').toLowerCase()}`;

  defineProps({
    testimonial: {
      type: Object,
      required: true
    }
  })
</script>

<template>
  <!-- Legacy repeater only ever bound one testimonial, so quote-right-1 was
       the only class ever emitted — the dead left/right alternation is not ported. -->
  <blockquote class="quote-right-1" :class="brandClass">
    "{{ testimonial.descr }}" <span>--{{ testimonial.name }}</span>
  </blockquote>
</template>

<style scoped>
  /* Ported from jweather-new-home-common.css + the per-brand new-home.css files */

  blockquote {
    color: #fff;
    font-size: 17px;
    width: 95%;
    margin: auto;
    text-align: center;
    padding: 2%;
  }

  blockquote span {
    display: block;
    font-style: italic;
    font-weight: bold;
    font-size: 17px;
  }

  .quote-right-1 {
    border-right: dotted 2px #fff;
    border-bottom: dotted 2px #fff;
  }

  /* -- Brand: WindAlert -- */
  .quote-right-1.home-brand-windalert {
    border-right-color: #000;
    border-bottom-color: #000;
  }

  .home-brand-windalert span {
    color: #fff;
  }

  /* -- Brand: iKitesurf -- */
  .quote-right-1.home-brand-ikitesurf {
    border-right-color: #1a81c4;
    border-bottom-color: #1a81c4;
  }

  .home-brand-ikitesurf span {
    color: #0056a0;
  }

  /* -- Brand: iWindsurf -- */
  .quote-right-1.home-brand-iwindsurf {
    border-right-color: #99ccff;
    border-bottom-color: #99ccff;
  }

  .home-brand-iwindsurf span {
    color: #163770;
  }

  /* -- Brands: SailFlow / FishWeather -- */
  .quote-right-1.home-brand-sailflow,
  .quote-right-1.home-brand-fishweather {
    border-right-color: #030e15;
    border-bottom-color: #030e15;
  }

  .home-brand-sailflow span,
  .home-brand-fishweather span {
    color: #fff;
  }
</style>
